import { render } from "./CardTable.vue?vue&type=template&id=4a0a62dc"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__